import { Component, input } from '@angular/core';
import { NoValuePipe } from '../../../../core/pipes/no-value/no-value.pipe';
import { OrgDatePipe } from '../../../../core/pipes/org-date/org-date.pipe';
import { UserMembershipModel } from '../../../../core/models/ui/user-membership.model';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Router } from '@angular/router';
import { ResponsiveTableDirective } from '../../../../core/directives/responsive-table/responsive-table.directive';
import { ResponsiveTableColumnDirective } from '../../../../core/directives/responsive-table/responsive-table-column.directive';

@Component({
  selector: 'ms-user-membership-list',
  imports: [CommonModule, FontAwesomeModule, NoValuePipe, OrgDatePipe, ResponsiveTableDirective, ResponsiveTableColumnDirective],
  templateUrl: './user-membership-list.component.html'
})
export class UserMembershipListComponent {

  constructor(private router: Router){}

  public memberships = input<UserMembershipModel[]>();

  public viewOrganization(organizationId: number | undefined): void {
    if (organizationId) {
      this.router.navigate([`organizations/profile/${organizationId}`]);
    }
  }

  public viewMemberProfile(memberId: number | undefined): void {
    if (memberId) {
      this.router.navigate([`members/profile/${memberId}`]);
    }
  }
}
